var React = require('react');

function Acceptance (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"clipRule":"evenodd","fill":"none","fillRule":"evenodd","id":"Done__x2014__Displayed_on_the_left_side_of_a_contextual_action_bar__x28_CAB_x29__to_allow_the_user_to_dismiss_it._2_","points":"  21.2,5.6 11.2,15.2 6.8,10.8 ","stroke":"#9c989e","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M19.9,13c-0.5,3.9-3.9,7-7.9,7c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8c1.4,0,2.7,0.4,3.9,1l1.5-1.5C15.8,2.6,14,2,12,2  C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10c5.2,0,9.4-3.9,9.9-9H19.9z","fill":"#9c989e","key":1})]);
}

Acceptance.defaultProps = {"aria-hidden":"true","focusable":"false","width":"1em","height":"1em","viewBox":"0 0 24 24"};

module.exports = Acceptance;

Acceptance.default = Acceptance;
